import { AnimationDriver } from '@angular/animations/browser';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';
import { ComProductEmployeeJobModel } from 'src/app/model/com-product-employee-job.model';
import { DependencyAffiliateModel, HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatBusinessProductModel, CatPromotionModel, CatSchemaModel } from 'src/app/model/other-catalogs-models';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductEmployeeJobService } from 'src/oldApp/services/com-product-employee-job.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { ModalScProductEmployeeJobComponent } from 'src/oldApp/shared/modal-sc-product-employee-job/modal-sc-product-employee-job.component';

@Component({
  selector: 'app-database-panel',
  templateUrl: './database-panel.component.html',
  styleUrls: ['./database-panel.component.css']
})
export class DatabasePanelComponent implements OnInit {
  // estado pagina
  public viewStatus=1;
  public page:string='DatabasePanel';
  public commissions:any[]=[];
  public schemaId:number=0;

  // catalogos
  public schemaCatalog:CatSchemaModel[]=[];
  public businessLineCatalog:HMGenericCatalog[]=[];
  public anchorTypeCatalog:HMGenericCatalog[]=[];
  public productCatalog:HMGenericCatalog[]=[];
  public paymentCatalog:HMGenericCatalog[]=[];
  public productCategoryCatalog:CatProductCategoryModel[]=[];
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public dealerCatalog:DependencyAffiliateModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 5,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private schemaService:OtherCatalogsService,
    private productEmployeeJobService:ComProductEmployeeJobService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private catProductCategoryService:CatCategoryProductService,
    private catEmployeeJobService:CatEmployeeJobService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  udpateSchema=()=> {
    this.viewStatus=0;
    forkJoin(
      this.productEmployeeJobService.getAllBySchema(this.schemaId)
    )
    .pipe(
      tap(([commResp]:[any])=> {
        if(commResp) {
          this.commissions=commResp;
          this.viewStatus=1;
        }
        else throwError;  
      }),
      catchError(error=> {
        console.log(error);
        this.commissions=[];
        this.viewStatus=1;
        return of(this.toastr.error('No se encontraron datos.'));
      })
    )
    .subscribe();
  }
  edit=(configuration)=> {
    let modalRef=this.modalService.open(ModalScProductEmployeeJobComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.configuration={...configuration};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.udpateSchema();
      }
    );
  }

  // HELPERS
  businessLine=item=> this.businessLineCatalog.find(bl=> bl.idCatalogType===item.businessProductId).description;
  anchorType=item=> this.anchorTypeCatalog.find(anc=> anc.idCatalogType===item.ownerTypeId).description;
  product=item=> this.productCatalog.find(pro=> pro.idCatalogType===item.productosCOEId).description;
  dealer=item=> this.dealerCatalog.find(dealer=> dealer.afiliateHMId===item.afiliateId).description;
  payment=item=> this.paymentCatalog.find(pay=> pay.idCatalogType===item.paymentId)?this.paymentCatalog.find(pay=> pay.idCatalogType===item.paymentId).description:'';
  productCategory=item=> this.productCategoryCatalog.find(cat=> cat.productCategoryId===item.productCategoryId).description;
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.schemaService.getListSchema(),
      this.hypermatrixCatalogsService.getCatalog('BusinessProductType'),
      this.hypermatrixCatalogsService.getCatalog('OwnerType'),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE'),
      this.hypermatrixCatalogsService.getCatalog('PaymentTermType'),
      this.catProductCategoryService.getAll(),
      this.catEmployeeJobService.getAll(),
      this.hypermatrixCatalogsService.getDependenciasAfiliadoHM()
    )
    .pipe(
      tap(([schemaResp, blResp, ownerResp, prodResp, payResp, prodCatResp, empJobResp, dealerResp]:[any, any, any, any, any, any, any, any])=> {
        if(schemaResp && blResp && ownerResp && prodResp && payResp && prodCatResp && empJobResp && dealerResp) {
          this.schemaCatalog=schemaResp;
          this.businessLineCatalog=blResp.data;
          this.anchorTypeCatalog=ownerResp.data;
          this.productCatalog=prodResp.data;
          this.paymentCatalog=payResp.data;
          this.productCategoryCatalog=prodCatResp;
          this.employeeJobCatalog=empJobResp;
          this.dealerCatalog=dealerResp.data;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}
